import SearchIcon from "@mui/icons-material/Search";
import { Box, Grid, InputAdornment, MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";
import ReusableTable from "../../../common/table/CommonTable";

const AdmissionsTable = ({ 
  data, 
  columns,
  isLoading, 
  currentPage,
  totalPages,
  onPageChange
}) => {
  const [filters, setFilters] = useState({
    search: "",
    status: "all",
    departmentName: "",
    wardName: ""
  });

  const handleFilterChange = (field, value) => {
    setFilters({
      ...filters,
      [field]: value
    });
  };

  // Extract unique departments and wards for filter dropdowns if needed
  // const departments = [...new Set(data?.map(item => item.departmentName) || [])];
  // const wards = [...new Set(data?.map(item => item.wardName) || [])];

  const filteredData = data?.filter(item => {
    const searchMatch = filters.search.trim() === "" || 
      Object.values(item).some(value => 
        value && typeof value === 'string' && 
        value.toLowerCase().includes(filters.search.toLowerCase())
      ) ||
      (item.admissionNo && item.admissionNo.toString().includes(filters.search)) ||
      (item.patientSerialNo && item.patientSerialNo.toString().includes(filters.search));
    const statusMatch = filters.status === 'all' || item.status === filters.status;
    const departmentMatch = filters.departmentName === '' || item.departmentName === filters.departmentName;
    const wardMatch = filters.wardName === '' || item.wardName === filters.wardName;
    return searchMatch && statusMatch && departmentMatch && wardMatch;
  }) || [];

  return (
    <>
      {/* Search and Filter Section */}
      <Box sx={{ mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={8}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              label="Search"
              value={filters.search}
              onChange={(e) => handleFilterChange("search", e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              placeholder="Search by ID, name, phone..."
            />
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              select
              fullWidth
              variant="outlined"
              size="small"
              label="Status"
              value={filters.status}
              onChange={(e) => handleFilterChange("status", e.target.value)}
            >
              <MenuItem value="all">All Statuses</MenuItem>
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="In Active">In Active</MenuItem>
              <MenuItem value="Discharged">Discharged</MenuItem>
            </TextField>
          </Grid>
          
          {/* Department and Ward filters can be uncommented if needed */}
          {/* <Grid item xs={12} sm={6} md={2.5}>
            <TextField
              select
              fullWidth
              variant="outlined"
              size="small"
              label="Department"
              value={filters.departmentName}
              onChange={(e) => handleFilterChange("departmentName", e.target.value)}
            >
              <MenuItem value="">All Departments</MenuItem>
              {departments.map((dept) => (
                <MenuItem key={dept} value={dept}>
                  {dept}
                </MenuItem>
              ))}
            </TextField>
          </Grid> */}
          
          {/* <Grid item xs={12} sm={6} md={3}>
            <TextField
              select
              fullWidth
              variant="outlined"
              size="small"
              label="Ward"
              value={filters.wardName}
              onChange={(e) => handleFilterChange("wardName", e.target.value)}
            >
              <MenuItem value="">All Wards</MenuItem>
              {wards.map((ward) => (
                <MenuItem key={ward} value={ward}>
                  {ward}
                </MenuItem>
              ))}
            </TextField>
          </Grid> */}
        </Grid>
      </Box>

      <ReusableTable
  title="Patients"
  columns={columns}
  data={filteredData}
  isLoading={isLoading}
  headerColor="#000"
  rowColor="#ffffff"
  alternateRowColor="#f5f5f5"
  withPagination={true}
  withActions={false}
  
  showDownloadOption={true}
  currentPage={currentPage}
  totalPages={totalPages}
  onPageChange={onPageChange}
/>
    </>
  );
};

export default AdmissionsTable;